// noinspection AllyJsxHardcodedStringInspection

import React, { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import cx from "classnames";
import { useModalPopup } from "hooks/useModalPopup";
import { Links } from "libs/constants";
import usePlatform from "hooks/usePlatform";

export const DMMPopup = () => {
	const { isDMMPopupOpen, closeDMMPopup } = useModalPopup();
	const { isMobilePlatform, isWindowsPlatform } = usePlatform();
	const [isInstalled, setIsInstalled] = useState(true);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	let timerInstallCheck: ReturnType<typeof setTimeout>;
	let timerBtnDisabled: ReturnType<typeof setTimeout>;

	const stopTimeout = () => clearTimeout(timerInstallCheck);

	const startPlayer = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		clearTimeout(timerInstallCheck);
		timerInstallCheck = setTimeout(function () {
			window.removeEventListener("blur", stopTimeout);
			setIsInstalled(false);
		}, 5000);

		window.focus();
		window.addEventListener("blur", stopTimeout);

		const iframe = document.createElement("iframe");
		iframe.src = Links.DMMPlayerUri;
		iframe.style.display = "none";
		document.body.appendChild(iframe);

		setIsButtonDisabled(true);
		clearTimeout(timerBtnDisabled);
		timerBtnDisabled = setTimeout(function () {
			setIsButtonDisabled(false);
		}, 5000);
	};

	return (
		<Transition appear show={isDMMPopupOpen} as={Fragment}>
			<Dialog
				as="div"
				className="relative z-20"
				onClose={closeDMMPopup}
			>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black/80" />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full transform overflow-hidden align-middle font-bold bg-black">
								<div className="dmm-popup">
									<div id="w">
										<div id="header">
											<h1>
												DMM GAME PLAYER はお持ちですか？
											</h1>
											<p>
												このゲームをプレイするためには、DMM
												GAME
												PLAYERをインストールしておく必要があります。
											</p>
										</div>
										<div className="container">
											<p
												className={cx(
													"tx-warning",
													isWindowsPlatform
														? "tx-warning--win"
														: "is-notwindow"
												)}
											>
												このゲームはWindows専用です。
											</p>
											<p
												className={cx(
													"tx-warning",
													isMobilePlatform
														? "is-notwindow"
														: "tx-warning--pc"
												)}
											>
												このゲームはPC専用です。
											</p>
											<p
												className={cx("tx-install", {
													"is-notinstalled":
														!isInstalled,
												})}
											>
												DMM GAME PLAYER
												が起動しない場合は、ダウンロードボタンからダウンロードをしてください。
											</p>
											<ul
												className={cx("box-btn", {
													inactive:
														isMobilePlatform || !isWindowsPlatform,
													"is-btn-disabled":
														isButtonDisabled,
												})}
											>
												<li className="start-enabled">
													<p>インストール済みの方</p>
													<a
														href={Links.DMMPlayerUri}
														className="btn btn-start transition-[background-color] duration-200 ease-in"
														onClick={startPlayer}
													>
														<span>
															今すぐプレイ！
														</span>
													</a>
												</li>
												<li className="start-disabled">
													<p>インストール済みの方</p>
													<div className="btn btn-loading">
														<img
															src="https://www.dmm.co.jp/images/common/ico/loading.gif"
															alt=""
														/>
														<span>
															処理中です･･･
														</span>
													</div>
												</li>
												<li>
													<p>未インストールの方</p>
													<a
														href={Links.DMMInstallerWinUrl}
														target="_blank"
														className="btn btn-install is-win transition-[background-color] duration-200 ease-in"
													>
														<span>
															DMM GAME PLAYER
															<br />
															インストール(Windows版)
														</span>
													</a>
												</li>
											</ul>
											<div
												className={cx("link-player", {
													"is-notinstalled":
														!isInstalled,
												})}
											>
												<a
													href="http://www.dmm.co.jp/netgame/top/guide/playerguide_html/=/ch_navi=/"
													target="_blank"
												>
													DMM GAME PLAYERとは？
												</a>
											</div>
											<p className={cx("mt-2 text-[#00000099] text-xs", { "hidden": !isWindowsPlatform })}>
												<a className="underline" href="https://terms.dmm.co.jp/member/" target="_blank">DMM会員規約</a>
												と
												<a className="underline" href="https://terms.dmm.co.jp/onlinegame_service/" target="_blank">GAMES利用規約</a>
												をお読みになり、すべての内容に同意のうえ、次へ進んでください。
											</p>
										</div>
									</div>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};
